<ng-container>
    <form>
        <mat-radio-group
            aria-label="program select"
            name="onceOffMatRadioGroup"
            [(ngModel)]="isExistingProgram"
            (change)="isExistingProgramChange()"
        >
            <mat-radio-button [value]="true" class="form-input">{{
                'forms.training.existingTrainingProgram' | appTranslate
            }}</mat-radio-button>
            <mat-form-field *ngIf="isExistingProgram">
                <mat-select
                    name="frequencyType"
                    [(ngModel)]="program"
                    placeholder="{{ 'forms.training.selectAnExistingTrainingProgram' | appTranslate }}"
                    (selectionChange)="programChange()"
                >
                    <mat-option *ngFor="let program of programs" [value]="program">{{ program.name }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-radio-button [value]="false" class="form-input new-program-name-radio">{{
                'forms.training.newTrainingProgram' | appTranslate
            }}</mat-radio-button>
            <mat-form-field *ngIf="isExistingProgram === false">
                <mat-label>{{ 'forms.training.name' | appTranslate }}</mat-label>
                <input
                    class="new-program-name-input"
                    type="text"
                    placeholder="{{ 'forms.training.egCprTraining' | appTranslate }}"
                    #name="ngModel"
                    name="name"
                    required
                    [(ngModel)]="programName"
                    matInput
                />
            </mat-form-field>
        </mat-radio-group>
    </form>
    <ng-container *ngIf="record">
        <app-form-training-record
            #trainingRecordForm
            [record]="record"
            (saveRecordEvent)="onSaveRecord()"
        ></app-form-training-record>
    </ng-container>
</ng-container>
